import { BulkAddElementInputWithMetadata } from 'models/getProjectElementNodesInput'
import { AllProjectResponse } from 'Models/project'
import { CategoryElementListStateInfo } from 'pages/ProjectsPage/WorkspacePage'
import { ElementItemIdentifier } from 'pages/ProjectsPage/WorkspacePage/components/ElementsPanel/ElementTreeView'
import React from 'react'

export interface IWorkspacePageContext {
    categoryElementStates: Record<string, CategoryElementListStateInfo>
    setCategoryElementStates: React.Dispatch<
        React.SetStateAction<Record<string, CategoryElementListStateInfo>>
    >
    selectedElementIdentifier: ElementItemIdentifier | undefined
    setSelectedElementIdentifier: React.Dispatch<
        React.SetStateAction<ElementItemIdentifier | undefined>
    >
    treeIndexerRef: React.MutableRefObject<Map<string, Map<string, number>>>
    projectData?: AllProjectResponse
    projectLoading: boolean | undefined
    reloadProject?: VoidFunction
    projectId?: string
    contentTeamFromStudioPage?: boolean
    selectedBulkAddElements?: BulkAddElementInputWithMetadata[]
    setSelectedBulkAddElements: React.Dispatch<
        React.SetStateAction<BulkAddElementInputWithMetadata[] | undefined>
    >
    refreshProjectElementNodes?: boolean
    handleRefreshProjectElementNodes?: (value: boolean) => void
}

export interface ProjectPageProviderProps {
    categoryElementStates: Record<string, CategoryElementListStateInfo>
    setCategoryElementStates: React.Dispatch<
        React.SetStateAction<Record<string, CategoryElementListStateInfo>>
    >
    selectedElementIdentifier: ElementItemIdentifier | undefined
    setSelectedElementIdentifier: React.Dispatch<
        React.SetStateAction<ElementItemIdentifier | undefined>
    >
    treeIndexerRef: React.MutableRefObject<Map<string, Map<string, number>>>
    projectData?: AllProjectResponse
    projectLoading?: boolean | undefined
    reloadProject?: VoidFunction
    projectId?: string
    contentTeamFromStudioPage?: boolean
    selectedBulkAddElements?: BulkAddElementInputWithMetadata[] | undefined
    setSelectedBulkAddElements: React.Dispatch<
        React.SetStateAction<BulkAddElementInputWithMetadata[] | undefined>
    >
    refreshProjectElementNodes?: boolean
    handleRefreshProjectElementNodes?: (value: boolean) => void
}

export const ProjectPageContext = React.createContext(
    {} as IWorkspacePageContext
)

const ProjectPageProvider: React.FC<ProjectPageProviderProps> = ({
    categoryElementStates,
    setCategoryElementStates,
    selectedElementIdentifier,
    setSelectedElementIdentifier,
    treeIndexerRef,
    children,
    projectData,
    projectLoading,
    reloadProject,
    projectId,
    contentTeamFromStudioPage,
    selectedBulkAddElements,
    setSelectedBulkAddElements,
    refreshProjectElementNodes,
    handleRefreshProjectElementNodes,
}) => {
    return (
        <ProjectPageContext.Provider
            value={{
                categoryElementStates,
                setCategoryElementStates,
                selectedElementIdentifier,
                setSelectedElementIdentifier,
                treeIndexerRef,
                projectData,
                projectLoading,
                reloadProject,
                projectId,
                contentTeamFromStudioPage,
                selectedBulkAddElements,
                setSelectedBulkAddElements,
                handleRefreshProjectElementNodes,
                refreshProjectElementNodes,
            }}
        >
            {children}
        </ProjectPageContext.Provider>
    )
}

export default ProjectPageProvider
